<div class="content">
    <div class="content-panel">
        <div class="infos">
            <p-button
                icon="pi pi-question"
                aria-label="Voir le détail des différents statuts"
                (click)="openInfos()"
                (keydown.enter)="openInfos()">
            </p-button>
        </div>
        @if (mails.length > 0) {
            <p-table
                #dt
                [value]="mails"
                [paginator]="true"
                [rows]="30"
                [scrollable]="true"
                scrollHeight="calc(100vh - 250px)">

                <ng-template pTemplate="header">
                    <tr>
                        @for (col of columns; track col) {
                            <th scope="col"
                                [pSortableColumn]="col.field"
                                [style.min-width]="col.width">
                                {{ col.label | translate }}
                                <p-sortIcon [field]="col.field" />
                                @if (col.filter === 'status' && mailsStatus.length > 1) {
                                    <p-columnFilter field="{{ col.field }}" matchMode="in" display="menu" [showOperator]="false" [showMatchModes]="false">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-multiselect [options]="mailsStatus"
                                                           (onChange)="filter($event.value)"
                                                           [ngModel]="value"
                                                           [filter]="false"
                                                           placeholder="Sélectionner un statut"
                                                           optionLabel="name"
                                                           optionValue="code"
                                                           display="chip">
                                            </p-multiselect>
                                        </ng-template>
                                    </p-columnFilter>
                                } @else {
                                    <p-columnFilter type="{{ col.filter }}" field="{{ col.field }}" display="menu" [showOperator]="false" />
                                }
                            </th>
                        }
                        <th scope="col"></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-mail>
                    <tr>
                        @for (col of columns; track col) {
                            <td [style.min-width]="col.width">
                                @if (col.field === 'dernierStatutCode') {
                                    <p-chip [label]="MailStatutLibelle[mail[col.field]]" [ngClass]="'status-chip ' + mail[col.field]"></p-chip>
                                } @else {
                                    {{ getCellValue(mail, col.field) }}
                                }
                            </td>
                        }
                        <td>
                            <p-button icon="pi pi-eye" aria-label="Voir l'historique des statuts" (click)="openHistorique(mail)"></p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        } @else {
            <p class="text-center">Aucun mail envoyé</p>
        }
    </div>
</div>

@if (showHistoriqueStatuts()) {
    @if (selectedMail(); as mail) {
        <historique-status
            [mail]="mail"
            [visible]="showHistoriqueStatuts()"
            (visibleChange)="onHistoriqueVisibleChange($event)" />
    }
}

<infos-statuts [(visible)]="showInfosStatuts" />
